import type { IAccountNumberHistory } from "@apis/accounts/types"
import type { IBasePtc } from "@apis/pricing/types"
import { type ColumnDef } from "@tanstack/react-table"
import { DateCell } from "@utils/table/columnFactories"
import { UpdateAccountNumberHistoryButton } from "../UpdateAccountNumberHistoryButton"
import { formatRate } from "@utils/formatters"
export const accountNumberHistoryColumns: ColumnDef<IAccountNumberHistory>[] = [
  {
    header: "Set Account Number",
    cell: ({ row }) => (
      <UpdateAccountNumberHistoryButton accountNumberHistory={row.original} />
    ),
  },
  { accessorKey: "account_number", header: "Account Number" },
  {
    accessorKey: "from_dt",
    header: "From Date",
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorKey: "to_dt",
    header: "To Date",
    cell: (props) => <DateCell {...props} />,
  },
]

export const ptcHistoryColumns: ColumnDef<IBasePtc>[] = [
  {
    accessorKey: "from_dt",
    header: "From Date",
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorKey: "to_dt",
    header: "To Date",
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorFn: (row) => formatRate(row.rate, row.rate_units),
    header: "PTC",
  },
]
